import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { MyDatePickerModule } from 'mydatepicker';

import { InlineEditComponent} from './inline-edit.component';

@NgModule({
  imports: [CommonModule, FormsModule, MyDatePickerModule],
  declarations: [InlineEditComponent],
  providers: [DatePipe],
  exports: [InlineEditComponent]
})
export class InlineEditorModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/inline-editor/inline-editor.module.ts